var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ui-auto-complete-busca',{ref:"fieldBusca",attrs:{"model":_vm.obj,"field":"uf","width":"1000","component":"app-estado-grid","label":"UF","autocomplete":_vm.autocomplete},on:{"change":_vm.altera}})}
var staticRenderFns = []

export { render, staticRenderFns }